import React from 'react';
import { Flex } from 'rebass';
//import Styled from 'styled-components';
import { Body1 } from '../components/FontStyles';
import ViewContainer from '../components/patterns/ViewContainer';
//import baseTheme from '../themes/baseTheme';
import Graph from '../components/elements/Graph';

class Summary extends React.Component {
  render() {
    return (
      <ViewContainer>
        <Flex width={1} justifyContent="center">
          <Body1>{this.props.patientName}</Body1>
          <Graph />
        </Flex>
      </ViewContainer>
    );
  }
}

export default Summary;
